import React from 'react';
import "./AdminGroup.css";
import { Glob as G } from "../libs/Glob.mjs";
import {AccordionBody, AccordionHeader, AccordionItem, Button, ButtonGroup, Label} from "reactstrap";
import AdminGroupUser from "./AdminGroupUser.mjs";
import Select from "react-select";
import LinkIcon from "../media/images/LinkIcon.mjs";
import TrashIcon from "../media/images/TrashIcon.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import HamburgerArea from "../controls/HamburgerArea.mjs";
import UnlinkIcon from "../media/images/UnlinkIcon.mjs";
import DownloadIcon from "../media/images/DownloadIcon.mjs";
import UploadIcon from "../media/images/UploadIcon.mjs";
import EditIcon from "../media/images/EditIcon.mjs";
import appLib from "../libs/appLib.mjs";

const prefix = 'AdminGroup';

const AdminGroup = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			addingUsers: [],
			showingAddArea: false
		};
		this.uid = G.generateUid(prefix);
	}
	render() {
		const g = this.props.group;
		if ( ! g?.id ) return '';
		const notInUsers = this.props.users
			.filter( u => ! u.groups.find( ug => ug.id === g.id))
			.map( u => ({ label: u.name, value: u.user }));
		const canShowAddArea =  notInUsers.length && g.id !== 'admin';
		return(
			<AccordionItem
				className={prefix + (g.id === 'admin' ? ' isAdmin' : ' nonAdmin' )}
				id={this.uid}
			>
				<AccordionHeader targetId={g.id}>
					{ g.id === 'admin' ? '' : (
						<HamburgerArea align={"start"}>
							<div
								className={"AdminGroupContextMemu"}
							>
								<ButtonGroup vertical={true}>
									<Label>
										<TextLabel value={"Group"}/>
									</Label>
									<Button
										className={"btn-icon"}
										color={"secondary"}
										onClick={() => { appLib.group(g.id) }}
									>
										<i>
											<TextLabel value={"forward"} lang={"icon"}/>
										</i>
										<b>
											<TextLabel value={"Browse"}/>
										</b>
									</Button>
									<Button
										className={"btn-icon"}
										color={"primary"}
										onClick={() => {
											this.props.editGroup(g.id)
										}}
									>
										<i>
											<EditIcon/>
										</i>
										<b>
											<TextLabel value={"Edit"}/>
										</b>
									</Button>
									<Button
										className={"btn-icon"}
										disabled={!canShowAddArea}
										color={this.state.showingAddArea ? "warning" : "success"}
										onClick={() => {
											this.setState({showingAddArea: !this.state.showingAddArea});
										}}
									>
										<i>
											{this.state.showingAddArea ? <UnlinkIcon/> : <LinkIcon/>}
										</i>
										<b>
											<TextLabel value={this.state.showingAddArea ? "Cancel" : "Users"}/>
										</b>
									</Button>
								</ButtonGroup>
								<ButtonGroup vertical={true}>
									<Button
										disabled={!!g.users.length}
										color={"danger"}
										className={"btn-icon"}
										onClick={() => {
											this.props.change('rmGroup', {id: g.id});
										}}
									>
										<i>
											<TrashIcon/>
										</i>
										<b>
											<TextLabel value={g.users.length ? 'Not empty' : 'Remove'}/>
										</b>
									</Button>
								</ButtonGroup>
								<ButtonGroup vertical={true}>
									<Label>
										<TextLabel value={"Form definition"}/>
									</Label>
									<Button
										color={"primary"}
										className={"btn-icon"}
										onClick={() => {
											G.gotoPage({ name:"EditForm", params: {group: g.id} });
										}}
									>
										<i>
											<EditIcon/>
										</i>
										<b>
											<TextLabel value={"Edit Form"}/>
										</b>
									</Button>
								</ButtonGroup>
								<ButtonGroup vertical={true}>
									<Button
										color={"secondary"}
										className={"btn-icon"}
										onClick={() => {
											G.api('getForm', {id: g.id}).then(res => {
												G.saveJSON(res, g.id + '.json');
											})
										}}
									>
										<i>
											<DownloadIcon/>
										</i>
										<b>
											<TextLabel value={"Download Form"}/>
										</b>
									</Button>
									<Button
										color={"warning"}
										className={"btn-icon"}
										onClick={() => {
											G.uploadJSON().then(data => {
												this.props.change('setForm/' + g.id, data);
											})
										}}
									>
										<i>
											<UploadIcon/>
										</i>
										<b>
											<TextLabel value={"Upload Form"}/>
										</b>
									</Button>
								</ButtonGroup>
							</div>
						</HamburgerArea>
					)}
					<strong>{g.name}</strong>
					{ g.id !== g.name ? ` (${g.id})`: '' }, 
					<TextLabel value={"members"}/>: <strong>{ g.users.length }</strong>
				</AccordionHeader>
				<AccordionBody accordionId={g.id}>
					{ (canShowAddArea && this.state.showingAddArea) ? (
						<table className={"AdminGroupAddArea"}>
							<tbody>
								<tr>
									<td>
										<Select
											placeholder={G.label('SelectMulti')}
											autoFocus={true}
											isMulti={true}
											isDisabled={notInUsers.length === 0}
											options={notInUsers}
											onChange={v => {
												this.setState({addingUsers: v.map(x => x.value)});
											}}
										/>
									</td>
									<td className={"ps-2"}>
										<ButtonGroup>
											<Button
												className={"btn-icon"}
												color={"warning"}
												title={ G.label('Cancel')}
												onClick={() => {
													this.setState({showingAddArea: false});
												}}
											>
												<UnlinkIcon/>
											</Button>
											<Button
												className={"btn-icon"}
												color={"success"}
												disabled={this.state.addingUsers.length === 0}
												onClick={() => {
													this.props.change('link', {
														user: this.state.addingUsers,
														group: g.id
													});
													this.setState({addingUsers: [], showingAddArea: false});
												}}
											>
												<b>
													<TextLabel value={"Add"}/>
												</b>
												<i>
													<LinkIcon/>
												</i>
											</Button>
										</ButtonGroup>
									</td>
								</tr>
							</tbody>
						</table>
					) : '' }
					{g.users.length ? (
						<table className={"UsersList"}>
							<thead>
							<tr>
								<th/>
								<th>
									<TextLabel value={"Login"} />
								</th>
								<th>
									<TextLabel value={"Name"} />
								</th>
								<th>
									<TextLabel value={"Email"} />
								</th>
								<th/>
							</tr>
							</thead>
							<tbody>
							{g.users.map(user => (
								<AdminGroupUser user={user} key={user.user} {...this.props} />
							))}
							</tbody>
						</table>
					) : (
						<div>
							<TextLabel value={"No users in this group"} />
						</div>
					)}
				</AccordionBody>
			</AccordionItem>
		)
	}
}

export default AdminGroup;
